function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.42188 14.2336C10.5595 13.2307 10.4034 15.2624 11.2015 15.2114C12.7092 15.2114 14.9708 15.2112 15.9759 14.9668C16.7298 17.1665 14.7195 16.9221 12.9605 17.1665M5.42188 17.9871C7.43217 18.4759 8.6886 19.1218 11.9553 21.0771C14.2169 21.0771 15.4733 20.3439 18.2375 19.6106C19.9965 18.8774 21.4644 18.5794 22.5094 17.6554C23.0119 16.4335 22.1403 16.2861 21.7555 16.3409C19.9827 16.5934 15.6894 18.3569 13.2118 17.4109",
  stroke: "#556677",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 13.4227C1.5 12.2749 2.73647 11.5524 3.73638 12.1159L4.39432 12.4866C4.86608 12.7525 5.15794 13.2519 5.15794 13.7934V18.5134C5.15794 19.0912 4.82602 19.6177 4.30464 19.8668L3.64671 20.1812C2.65115 20.6569 1.5 19.9311 1.5 18.8277V13.4227Z",
  stroke: "#556677"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 9.49992C12.5 9.49992 15.5 10.9999 15.5 8.99993C15.5 7.19715 12.5 8.08105 12.5 6.49993C12.5 4.99992 14.5 4.99994 15.5 5.99994",
  stroke: "#556677",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14 10.5L14 4.5",
  stroke: "#556677",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.8905,
  cy: 7.42174,
  r: 4.77174,
  stroke: "#556677",
  strokeWidth: 1.3
});
const SvgPaymentsIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPaymentsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/payments-icon.090d847f.svg";
export { ForwardRef as ReactComponent };